import { ALT } from '@/store/experience';

let seed = 7;
const rnd = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
const range = (a, b) => a + rnd() * (b - a);

// Distributes cloud sprites across the whole vertical journey:
// sparse high sky → dense deck (the engulf moment) → website descent column.
export function buildCloudData(count, frontCount) {
  seed = 7;
  const back = [], front = [];
  const push = (arr, x, y, z, s) => arr.push({ x, y, z, s, rot: range(-0.3, 0.3), v: Math.floor(rnd() * 4), ph: rnd() * 6.28 });
  const bottom = ALT.HERO - ALT.DESCENT - 60;

  for (let i = 0; i < count; i++) {
    const r = rnd();
    if (r < 0.1) push(back, range(-160, 160), range(ALT.DECK_TOP + 30, ALT.PLANE - 40), range(-140, -30), range(22, 50));
    else if (r < 0.42) push(back, range(-110, 110), range(ALT.DECK_BOTTOM - 12, ALT.DECK_TOP + 6), range(-80, -9), range(18, 44));
    else push(back, range(-95, 95), range(bottom, ALT.HERO + 40), range(-90, -9), range(16, 42));
  }
  for (let i = 0; i < frontCount; i++) {
    const r = rnd();
    if (r < 0.45) push(front, range(-14, 14), range(ALT.DECK_BOTTOM - 6, ALT.DECK_TOP), range(-7.5, -2), range(3, 8));
    else {
      const side = rnd() > 0.5 ? 1 : -1;
      push(front, side * range(6, 16), range(bottom, ALT.HERO + 30), range(-7.5, -3), range(2.5, 6));
    }
  }
  return { back, front };
}
